/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS201: Simplify complex destructure assignments
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

function loadAsyncJS(url, ...rest) {
  const adjustedLength = Math.max(rest.length, 1);
  const cb = rest[adjustedLength - 1];
  const args = rest.slice(0, adjustedLength - 1);

  if (!url) {
    return;
  }
  const [id] = args;
  const doc = window.document;
  const script = doc.createElement('script');
  script.async = true;
  script.src = url;
  if (typeof id === 'string') {
    script.id = id;
  }
  if (typeof cb === 'function') {
    script.onload = cb;
  }
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(script, s);
}

// Groupon.Utils.loadAsyncJS:

module.exports = loadAsyncJS;
